import React, { ReactElement, useState } from "react";
import type { Ref } from "react";
import { View, TextInput, TextInputProps, StyleSheet } from "react-native";
import { Text } from "../../components/Text";
import { inputTextStyles as styles } from "./styles";
import InputError from "./InputError";
import { CountrySelector } from "./CountrySelector";
import { countries, type Country } from "../../types/country-types";

export type MobileNumberInputProps = {
  inputLabel: string;
  inputRef?: Ref<any>;
  lastField?: boolean;
  error?: string;
  returnKeyType?: string;
  showError?: boolean;
} & TextInputProps;

export const MobileNumberInput = ({
  inputLabel,
  inputRef,
  lastField = false,
  error,
  showError = false,
  value = "",
  onChangeText,
  ...props
}: MobileNumberInputProps): ReactElement => {
  const [selectedCountry, setSelectedCountry] = useState<Country>(countries[0]);

  const handleCountryChange = (country: Country) => {
    setSelectedCountry(country);
    const numberWithoutPrefix = value.replace(/^00\d{3}/, "");
    if (onChangeText) {
      onChangeText(country.prefix + numberWithoutPrefix);
    }
  };

  const handleNumberChange = (text: string) => {
    if (onChangeText) {
      const digitsOnly = text.replace(/\D/g, "");
      if (!digitsOnly.startsWith(selectedCountry.prefix)) {
        onChangeText(selectedCountry.prefix + digitsOnly);
      } else {
        onChangeText(digitsOnly);
      }
    }
  };

  const displayValue = value.replace(selectedCountry.prefix, "");

  const newStyles = StyleSheet.create({
    rowContainer: {
      flex: 1,
      flexDirection: "row",
      paddingTop: 10,
    },
    dropdownContainer: {
      width: "15%",
    },
    textInputContainer: {
      flex: 1,
    },
  });

  return (
    <View style={styles.inputContainer}>
      <Text style={[styles.inputLabelText]}>{inputLabel}</Text>
      <View style={newStyles.rowContainer}>
        <View style={newStyles.dropdownContainer}>
          <CountrySelector
            selectedCountry={selectedCountry}
            onSelectCountry={handleCountryChange}
          />
        </View>
        <View style={newStyles.textInputContainer}>
          <TextInput
            ref={inputRef}
            style={styles.inputText}
            testID="telephoneInput"
            value={displayValue}
            onChangeText={handleNumberChange}
            keyboardType="numeric"
            {...props}
          />
        </View>
      </View>
      {showError && <InputError error={error} />}
    </View>
  );
};

export default MobileNumberInput;
